<template>
  <div>
    <h1>Productos</h1>
    <List :items="products" :columns="columns" />
  </div>
</template>

<script>
import List from "@/components/gotrading/common/List.vue";
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "ProductsPage",
  components: { List },
  data() {
    return {
      products: [],
      columns: [
        { key: "name", label: "Nombre del producto" },
        { key: "price", label: "Precio ($)" },
        { key: "stock", label: "Stock disponible" },
      ],
    };
  },
  async mounted() {
    try {
      const response = await wencesApi.get("/api/gotrading/products/all");
      this.products = response.data;
    } catch (error) {
      console.error("Error al obtener productos:", error);
    }
  },
};
</script>
